import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import ErrorPage from '@/containers/ErrorPage'
import { Card } from '@/shared/theme/styled-components'

import BreakCounter from './BreakCounter/BreakCounter'
import BreakExportForm from './BreakExportForm/BreakExportForm'
import BreakSettingsForm from './BreakSettingsForm/BreakSettingsForm'
import BreakToggle from './BreakToggle/BreakToggle'
import ForceStopModal from './ForceStopModal/ForceStopModal'
import LimitReachedModal from './LimitReachedModal/LimitReachedModal'
import OperatorsTable from './OperatorsTable/OperatorsTable'
import useBreakManagementPage from './useBreakManagementPage'

const BREAK_MANAGEMENT_PATH = 'gestione-pause'

const BreakManagementPage = () => {
  const { t, country, isAvailable, isAdmin, isLoading, error, currentCount, max } = useBreakManagementPage()

  if (!isAvailable) {
    return <ErrorPage hasErrorType currentType={BREAK_MANAGEMENT_PATH} hasErrorCountry={false} currentCountry={country} />
  }

  return (
    <Card>
      <SDNotification type='negative' hidden={!error} primaryText={String(error ?? '')} />
      <SDLoader hidden={!isLoading} text={t('common:fetching_data')} />
      <BreakToggle />
      <BreakCounter label={t('breakManagement:counter')} currentCount={currentCount} max={max} />
      <BreakSettingsForm hidden={!isAdmin} />
      <BreakExportForm hidden={!isAdmin} />
      <OperatorsTable hidden={!isAdmin} />
      <LimitReachedModal />
      <ForceStopModal />
    </Card>
  )
}

export default BreakManagementPage
